<template>
  <div>
    <section class="xs-banner service-banner contet-to-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-5 align-self-center">
            <div class="xs-banner-content">
              <h1 class="banner-sub-title wow fadeInLeft">GENERAL QUESTIONS</h1>
              <h2 class="banner-title wow fadeInLeft" data-wow-duration="1.5s">Common FAQs</h2>
              <ul class="breadcrumbs list-inline wow fadeInLeft" data-wow-duration="2s">
                <li><a href="https://episcloud.com">Home</a></li>
                <li>Support</li>
              </ul>
              <p class="wow fadeInUp" data-wow-duration="1.5s"></p>
            </div><!-- .xs-banner-content END -->
          </div>
          <div class="col-lg-6 col-md-7">
            <div class="inner-welcome-image-group">
              <img src="../assets/images/about-bg.png" alt="Welcome banner image">
              <img src="../assets/images/info-1.png" class="banner-ico banner-ico-1"
                   alt="banner icon"><img src="../assets/images/board.png"
                                          class="banner-ico banner-ico-2" alt="banner icon"></div>
          </div>
        </div><!-- .row END -->
      </div><!-- .container END -->
    </section>
    <div class="page" role="main">
      <div class="builder-content">
        <!-- full-width-content -->
        <div id="post-36" class="full-width-content post-36 page type-page status-publish hentry">
          <div data-elementor-type="wp-post" data-elementor-id="36" class="elementor elementor-36"
               data-elementor-settings="[]">
            <div class="elementor-inner">
              <div class="elementor-section-wrap">
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-9e99637 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="9e99637" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-b14b250"
                        data-id="b14b250" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-ef9a36b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="ef9a36b" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-c6df752"
                                    data-id="c6df752" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-23201c9"
                                    data-id="23201c9" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-7eaa4a3 elementor-widget elementor-widget-xs-heading"
                                          data-id="7eaa4a3" data-element_type="widget"
                                          data-widget_type="xs-heading.default">
                                          <div class="elementor-widget-container">
                                            <div class="xs-heading">
                                              <h3 class="heading-sub-title">Our Support</h3>
                                              <h2 class="heading-title">GENERAL <span>QUESTION</span></h2>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-d2a7f51"
                                    data-id="d2a7f51" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-096567a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="096567a" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-247adee"
                                    data-id="247adee" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-5399759 elementor-widget elementor-widget-heading"
                                          data-id="5399759" data-element_type="widget"
                                          data-widget_type="heading.default">
                                          <div class="elementor-widget-container">
                                            <h4 class="elementor-heading-title elementor-size-default">Shared
                                              Hosting</h4></div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-2ee9d00 elementor-widget elementor-widget-toggle"
                                          data-id="2ee9d00" data-element_type="widget"
                                          data-widget_type="toggle.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-toggle" role="tablist">
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-4911" class="elementor-tab-title"
                                                     data-tab="1" role="tab" aria-controls="elementor-tab-content-4911"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">Do you offer managed
                                                    hosting?</a>
                                                </div>

                                                <div id="elementor-tab-content-4911"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="1"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-4911">No, its
                                                  completely unmanaged — if you experience issues with your server, you
                                                  can reach out to our support team.
                                                </div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-4912" class="elementor-tab-title"
                                                     data-tab="2" role="tab" aria-controls="elementor-tab-content-4912"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How to buy a domain in cheap
                                                    price?</a>
                                                </div>

                                                <div id="elementor-tab-content-4912"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="2"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-4912">Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch
                                                </div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-4913" class="elementor-tab-title"
                                                     data-tab="3" role="tab" aria-controls="elementor-tab-content-4913"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How do I set up a URL
                                                    redirect for a domain?</a>
                                                </div>

                                                <div id="elementor-tab-content-4913"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="3"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-4913">Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch
                                                </div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-4914" class="elementor-tab-title"
                                                     data-tab="4" role="tab" aria-controls="elementor-tab-content-4914"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How can I change the
                                                    nameservers for my domain?</a>
                                                </div>

                                                <div id="elementor-tab-content-4914"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="4"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-4914">Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch
                                                </div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-4915" class="elementor-tab-title"
                                                     data-tab="5" role="tab" aria-controls="elementor-tab-content-4915"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How do I generate a CSR
                                                    code?</a>
                                                </div>

                                                <div id="elementor-tab-content-4915"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="5"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-4915">Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                                                  Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid
                                                  single-origin.
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-78d8493 elementor-widget elementor-widget-heading"
                                          data-id="78d8493" data-element_type="widget"
                                          data-widget_type="heading.default">
                                          <div class="elementor-widget-container">
                                            <h4 class="elementor-heading-title elementor-size-default">Dedicated
                                              Hosting</h4></div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-5e9f4bd elementor-widget elementor-widget-toggle"
                                          data-id="5e9f4bd" data-element_type="widget"
                                          data-widget_type="toggle.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-toggle" role="tablist">
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-9921" class="elementor-tab-title"
                                                     data-tab="1" role="tab" aria-controls="elementor-tab-content-9921"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How to set up Free Email
                                                    Forwarding</a>
                                                </div>

                                                <div id="elementor-tab-content-9921"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="1"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-9921"><p>No,
                                                  its completely unmanaged — if you experience issues with your server,
                                                  you can reach out to our support team.</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-9922" class="elementor-tab-title"
                                                     data-tab="2" role="tab" aria-controls="elementor-tab-content-9922"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How do I transfer a
                                                    domain?</a>
                                                </div>

                                                <div id="elementor-tab-content-9922"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="2"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-9922"><p>Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-9923" class="elementor-tab-title"
                                                     data-tab="3" role="tab" aria-controls="elementor-tab-content-9923"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How to transfer an existing
                                                    hosting account?</a>
                                                </div>

                                                <div id="elementor-tab-content-9923"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="3"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-9923"><p>Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-9924" class="elementor-tab-title"
                                                     data-tab="4" role="tab" aria-controls="elementor-tab-content-9924"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How do I renew my
                                                    domain?</a>
                                                </div>

                                                <div id="elementor-tab-content-9924"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="4"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-9924"><p>Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-9925" class="elementor-tab-title"
                                                     data-tab="5" role="tab" aria-controls="elementor-tab-content-9925"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How does WhoisGuard work for
                                                    keep secure?</a>
                                                </div>

                                                <div id="elementor-tab-content-9925"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="5"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-9925"><p>Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                                                  Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid
                                                  single-origin.</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-11fba82"
                                    data-id="11fba82" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-b77129a elementor-widget elementor-widget-heading"
                                          data-id="b77129a" data-element_type="widget"
                                          data-widget_type="heading.default">
                                          <div class="elementor-widget-container">
                                            <h4 class="elementor-heading-title elementor-size-default">Dedicated
                                              Hosting</h4></div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-7979c15 elementor-widget elementor-widget-toggle"
                                          data-id="7979c15" data-element_type="widget"
                                          data-widget_type="toggle.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-toggle" role="tablist">
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-1271" class="elementor-tab-title"
                                                     data-tab="1" role="tab" aria-controls="elementor-tab-content-1271"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How to set up Free Email
                                                    Forwarding</a>
                                                </div>

                                                <div id="elementor-tab-content-1271"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="1"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-1271"><p>No,
                                                  its completely unmanaged — if you experience issues with your server,
                                                  you can reach out to our support team.</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-1272" class="elementor-tab-title"
                                                     data-tab="2" role="tab" aria-controls="elementor-tab-content-1272"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How do I transfer a
                                                    domain?</a>
                                                </div>

                                                <div id="elementor-tab-content-1272"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="2"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-1272"><p>Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-1273" class="elementor-tab-title"
                                                     data-tab="3" role="tab" aria-controls="elementor-tab-content-1273"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How to transfer an existing
                                                    hosting account?</a>
                                                </div>

                                                <div id="elementor-tab-content-1273"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="3"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-1273"><p>Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-1274" class="elementor-tab-title"
                                                     data-tab="4" role="tab" aria-controls="elementor-tab-content-1274"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How do I renew my
                                                    domain?</a>
                                                </div>

                                                <div id="elementor-tab-content-1274"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="4"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-1274"><p>Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-1275" class="elementor-tab-title"
                                                     data-tab="5" role="tab" aria-controls="elementor-tab-content-1275"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title"> How does WhoisGuard work
                                                    for keep secure? </a>
                                                </div>

                                                <div id="elementor-tab-content-1275"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="5"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-1275"><p>Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                                                  Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid
                                                  single-origin.</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-1cb3eb3 elementor-widget elementor-widget-heading"
                                          data-id="1cb3eb3" data-element_type="widget"
                                          data-widget_type="heading.default">
                                          <div class="elementor-widget-container">
                                            <h4 class="elementor-heading-title elementor-size-default">VPS Hosting</h4>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-64b1238 elementor-widget elementor-widget-toggle"
                                          data-id="64b1238" data-element_type="widget"
                                          data-widget_type="toggle.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-toggle" role="tablist">
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-1051" class="elementor-tab-title"
                                                     data-tab="1" role="tab" aria-controls="elementor-tab-content-1051"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How to set up Free Email
                                                    Forwarding</a>
                                                </div>

                                                <div id="elementor-tab-content-1051"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="1"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-1051"><p>No,
                                                  its completely unmanaged — if you experience issues with your server,
                                                  you can reach out to our support team.</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-1052" class="elementor-tab-title"
                                                     data-tab="2" role="tab" aria-controls="elementor-tab-content-1052"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How do I transfer a
                                                    domain?</a>
                                                </div>

                                                <div id="elementor-tab-content-1052"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="2"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-1052"><p>Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-1053" class="elementor-tab-title"
                                                     data-tab="3" role="tab" aria-controls="elementor-tab-content-1053"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How to transfer an existing
                                                    hosting account?</a>
                                                </div>

                                                <div id="elementor-tab-content-1053"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="3"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-1053"><p>Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-1054" class="elementor-tab-title"
                                                     data-tab="4" role="tab" aria-controls="elementor-tab-content-1054"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How do I renew my
                                                    domain?</a>
                                                </div>

                                                <div id="elementor-tab-content-1054"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="4"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-1054"><p>Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-1055" class="elementor-tab-title"
                                                     data-tab="5" role="tab" aria-controls="elementor-tab-content-1055"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title"> How does WhoisGuard work
                                                    for keep secure? </a>
                                                </div>

                                                <div id="elementor-tab-content-1055"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="5"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-1055"><p>Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                                                  Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid
                                                  single-origin.</p>
                                                  <p>&nbsp;</p></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-5285c3e elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="5285c3e" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-0ec8f0e"
                        data-id="0ec8f0e" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-5d2a32c elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="5d2a32c" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-b8d92ab"
                                    data-id="b8d92ab" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-645f601"
                                    data-id="645f601" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-8ebbf4c elementor-widget elementor-widget-xs-heading"
                                          data-id="8ebbf4c" data-element_type="widget"
                                          data-widget_type="xs-heading.default">
                                          <div class="elementor-widget-container">
                                            <div class="xs-heading">
                                              <h3 class="heading-sub-title">Have question?</h3>
                                              <h2 class="heading-title">ASK <span>A QUESTION</span></h2>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-0eb1e64"
                                    data-id="0eb1e64" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-90a7f02 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="90a7f02" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-37c566e"
                                    data-id="37c566e" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-b4f7341"
                                    data-id="b4f7341" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-6c9f70e elementor-widget elementor-widget-shortcode"
                                          data-id="6c9f70e" data-element_type="widget"
                                          data-widget_type="shortcode.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-shortcode">
                                              <div role="form" class="wpcf7" id="wpcf7-f5-p36-o1" lang="en-US"
                                                   dir="ltr">
                                                <div class="screen-reader-response"><p role="status" aria-live="polite"
                                                                                       aria-atomic="true"></p>
                                                  <ul></ul>
                                                </div>
                                                <form action="/support/#wpcf7-f5-p36-o1" method="post"
                                                      class="wpcf7-form init" novalidate="novalidate"
                                                      data-status="init">
                                                  <div style="display: none;">
                                                    <input type="hidden" name="_wpcf7" value="5" autocomplete="off"
                                                           autocorrect="off">
                                                    <input type="hidden" name="_wpcf7_version" value="5.4.2"
                                                           autocomplete="off" autocorrect="off">
                                                    <input type="hidden" name="_wpcf7_locale" value="en_US"
                                                           autocomplete="off" autocorrect="off">
                                                    <input type="hidden" name="_wpcf7_unit_tag" value="wpcf7-f5-p36-o1"
                                                           autocomplete="off" autocorrect="off">
                                                    <input type="hidden" name="_wpcf7_container_post" value="36"
                                                           autocomplete="off" autocorrect="off">
                                                    <input type="hidden" name="_wpcf7_posted_data_hash" value=""
                                                           autocomplete="off" autocorrect="off">
                                                  </div>
                                                  <div id="xs-contact-form" class="xs-form">
                                                    <div class="form-group">
                                                      <span class="wpcf7-form-control-wrap text-name"><input type="text"
                                                                                                             name="text-name"
                                                                                                             value=""
                                                                                                             size="40"
                                                                                                             class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control"
                                                                                                             id="xs_contact_name"
                                                                                                             aria-required="true"
                                                                                                             aria-invalid="false"
                                                                                                             placeholder="Name"
                                                                                                             autocomplete="off"
                                                                                                             autocorrect="off"></span><br>
                                                      <span class="wpcf7-form-control-wrap your-email"><input
                                                        type="email" name="your-email" value="" size="40"
                                                        class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email form-control"
                                                        id="xs_contact_email" aria-required="true" aria-invalid="false"
                                                        placeholder="example@gmail.com" autocomplete="off"
                                                        autocorrect="off"></span><br>
                                                      <span class="wpcf7-form-control-wrap url-website"><input
                                                        type="url" name="url-website" value="" size="40"
                                                        class="wpcf7-form-control wpcf7-text wpcf7-url wpcf7-validates-as-required wpcf7-validates-as-url form-control"
                                                        id="xs_contact_website" aria-required="true"
                                                        aria-invalid="false" placeholder="Website" autocomplete="off"
                                                        autocorrect="off"></span><br>
                                                      <span class="wpcf7-form-control-wrap textarea-massage"><textarea
                                                        name="textarea-massage" cols="40" rows="10"
                                                        class="wpcf7-form-control wpcf7-textarea form-control"
                                                        id="x_contact_massage" aria-invalid="false"
                                                        placeholder="Question"></textarea></span>
                                                    </div>
                                                    <div class="xs-btn-wraper">
                                                      <input type="submit" value="Submit Now"
                                                             class="wpcf7-form-control wpcf7-submit btn btn-primary"
                                                             id="xs_contact_submit" autocomplete="off"
                                                             autocorrect="off"><span class="ajax-loader"></span>
                                                    </div>
                                                  </div>
                                                  <div class="wpcf7-response-output" aria-hidden="true"></div>
                                                </form>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-efca547"
                                    data-id="efca547" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-0ac3c96 elementor-section-height-min-height elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
                  data-id="0ac3c96" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;gradient&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2fc8d65"
                        data-id="2fc8d65" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-b0fe0d1 elementor-widget elementor-widget-xs-testimonial"
                              data-id="b0fe0d1" data-element_type="widget" data-widget_type="xs-testimonial.default">
                              <div class="elementor-widget-container">
                                <div class="xs-testimonial-slider owl-carousel owl-loaded owl-drag">

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <div class="owl-stage-outer">
                                    <div class="owl-stage"
                                         style="transition: all 0s ease 0s; width: 3834px; transform: translate3d(-766px, 0px, 0px);">
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned active" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-4-55x55.jpg"
                                                  alt="avatar-4" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item active center" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-3-55x55.png"
                                                  alt="avatar-3" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-4-55x55.jpg"
                                                  alt="avatar-4" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-3-55x55.png"
                                                  alt="avatar-3" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="owl-nav disabled">
                                    <div class="owl-prev"></div>
                                    <div class="owl-next"></div>
                                  </div>
                                  <div class="owl-dots disabled"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-bc980b0 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="bc980b0" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-5de7bea"
                        data-id="5de7bea" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-c80337f elementor-widget elementor-widget-xs-partner"
                              data-id="c80337f" data-element_type="widget" data-widget_type="xs-partner.default">
                              <div class="elementor-widget-container">
                                <div class="xs-client-slider owl-carousel owl-loaded owl-drag">


                                  <div class="owl-stage-outer">
                                    <div class="owl-stage"
                                         style="transform: translate3d(-1120px, 0px, 0px); transition: all 0s ease 0s; width: 3360px;">
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="owl-nav disabled">
                                    <div class="owl-prev"></div>
                                    <div class="owl-next"></div>
                                  </div>
                                  <div class="owl-dots disabled"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-f5516c2 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="f5516c2" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-dfea7b2 animated-slow animated fadeInLeft"
                        data-id="dfea7b2" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInLeft&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-6832010 elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="6832010" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="122" height="138"
                                           src="../assets/images/sheild-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Days money back guarantee</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-a71815c animated-slow animated fadeInRight"
                        data-id="a71815c" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-a0eeee3 elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="a0eeee3" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="129" height="138"
                                           src="../assets/images/cloud-lock-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Build and protect your brand</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-4d5ed22 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="4d5ed22" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-07a99c1"
                        data-id="07a99c1" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-8df6d89 elementor-widget elementor-widget-spacer"
                              data-id="8df6d89" data-element_type="widget" data-widget_type="spacer.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-spacer">
                                  <div class="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div> <!-- end full-width-content -->
      </div> <!-- end main-content -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'Support'
}
</script>

<style scoped>
.elementor-36 .elementor-element.elementor-element-9e99637 {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  padding: 80px 10px 80px 10px;
}

.elementor-36 .elementor-element.elementor-element-9e99637 > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-36 .elementor-element.elementor-element-5399759 .elementor-heading-title {
  color: #1e1e1e;
  font-size: 1.17647rem;
  font-weight: 500;
}

.elementor-36 .elementor-element.elementor-element-5399759 > .elementor-widget-container {
  margin: 0px 0px 35px 0px;
}

.elementor-36 .elementor-element.elementor-element-2ee9d00 .elementor-toggle-item:not(:last-child) {
  margin-bottom: 17px;
}

.elementor-36 .elementor-element.elementor-element-2ee9d00 .elementor-tab-title {
  background-color: #F8FAFE;
  padding: 19px 30px 19px 30px;
}

.elementor-36 .elementor-element.elementor-element-2ee9d00 .elementor-toggle-title, .elementor-36 .elementor-element.elementor-element-2ee9d00 .elementor-toggle-icon {
  color: #000000;
}

.elementor-36 .elementor-element.elementor-element-2ee9d00 .elementor-toggle-icon svg {
  fill: #000000;
}

.elementor-36 .elementor-element.elementor-element-2ee9d00 .elementor-tab-content {
  background-color: #ffffff;
  color: #70799f;
  font-family: "Karla", Sans-serif;
  letter-spacing: -0.4px;
  padding: 0px 30px 30px 30px;
}

.elementor-36 .elementor-element.elementor-element-2ee9d00 > .elementor-widget-container {
  margin: 0px 0px 75px 0px;
}

.elementor-36 .elementor-element.elementor-element-78d8493 .elementor-heading-title {
  color: #1e1e1e;
  font-size: 1.17647rem;
  font-weight: 500;
}

.elementor-36 .elementor-element.elementor-element-78d8493 > .elementor-widget-container {
  margin: 0px 0px 35px 0px;
}

.elementor-36 .elementor-element.elementor-element-5e9f4bd .elementor-toggle-item:not(:last-child) {
  margin-bottom: 17px;
}

.elementor-36 .elementor-element.elementor-element-5e9f4bd .elementor-tab-title {
  background-color: #F8FAFE;
  padding: 19px 30px 19px 30px;
}

.elementor-36 .elementor-element.elementor-element-5e9f4bd .elementor-toggle-title, .elementor-36 .elementor-element.elementor-element-5e9f4bd .elementor-toggle-icon {
  color: #000000;
}

.elementor-36 .elementor-element.elementor-element-5e9f4bd .elementor-toggle-icon svg {
  fill: #000000;
}

.elementor-36 .elementor-element.elementor-element-5e9f4bd .elementor-tab-content {
  background-color: #ffffff;
  color: #70799f;
  font-family: "Karla", Sans-serif;
  letter-spacing: -0.4px;
  padding: 0px 30px 30px 30px;
}

.elementor-36 .elementor-element.elementor-element-b77129a .elementor-heading-title {
  color: #1e1e1e;
  font-size: 1.17647rem;
  font-weight: 500;
}

.elementor-36 .elementor-element.elementor-element-b77129a > .elementor-widget-container {
  margin: 0px 0px 35px 0px;
}

.elementor-36 .elementor-element.elementor-element-7979c15 .elementor-toggle-item:not(:last-child) {
  margin-bottom: 17px;
}

.elementor-36 .elementor-element.elementor-element-7979c15 .elementor-tab-title {
  background-color: #F8FAFE;
  padding: 19px 30px 19px 30px;
}

.elementor-36 .elementor-element.elementor-element-7979c15 .elementor-toggle-title, .elementor-36 .elementor-element.elementor-element-7979c15 .elementor-toggle-icon {
  color: #000000;
}

.elementor-36 .elementor-element.elementor-element-7979c15 .elementor-toggle-icon svg {
  fill: #000000;
}

.elementor-36 .elementor-element.elementor-element-7979c15 .elementor-tab-content {
  background-color: #ffffff;
  color: #70799f;
  font-family: "Karla", Sans-serif;
  letter-spacing: -0.4px;
  padding: 0px 30px 30px 30px;
}

.elementor-36 .elementor-element.elementor-element-7979c15 > .elementor-widget-container {
  margin: 0px 0px 75px 0px;
}

.elementor-36 .elementor-element.elementor-element-1cb3eb3 .elementor-heading-title {
  color: #1e1e1e;
  font-size: 1.17647rem;
  font-weight: 500;
}

.elementor-36 .elementor-element.elementor-element-1cb3eb3 > .elementor-widget-container {
  margin: 0px 0px 35px 0px;
}

.elementor-36 .elementor-element.elementor-element-64b1238 .elementor-toggle-item:not(:last-child) {
  margin-bottom: 17px;
}

.elementor-36 .elementor-element.elementor-element-64b1238 .elementor-tab-title {
  background-color: #F8FAFE;
  padding: 19px 30px 19px 30px;
}

.elementor-36 .elementor-element.elementor-element-64b1238 .elementor-toggle-title, .elementor-36 .elementor-element.elementor-element-64b1238 .elementor-toggle-icon {
  color: #000000;
}

.elementor-36 .elementor-element.elementor-element-64b1238 .elementor-toggle-icon svg {
  fill: #000000;
}

.elementor-36 .elementor-element.elementor-element-64b1238 .elementor-tab-content {
  background-color: #ffffff;
  color: #70799f;
  font-family: "Karla", Sans-serif;
  letter-spacing: -0.4px;
  padding: 0px 30px 30px 30px;
}

.elementor-36 .elementor-element.elementor-element-5285c3e:not(.elementor-motion-effects-element-type-background), .elementor-36 .elementor-element.elementor-element-5285c3e > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-color: #f8fafe;
}

.elementor-36 .elementor-element.elementor-element-5285c3e {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  padding: 80px 10px 80px 10px;
}

.elementor-36 .elementor-element.elementor-element-5285c3e > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-36 .elementor-element.elementor-element-0ac3c96 > .elementor-container {
  min-height: 500px;
}

.elementor-36 .elementor-element.elementor-element-0ac3c96 {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
}

.elementor-36 .elementor-element.elementor-element-0ac3c96 > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-36 .elementor-element.elementor-element-b0fe0d1 .xs-testimonial-slider .owl-item .xs-testimonial-item::before, .xs-testimonial-slider .owl-item .xs-testimonial-item::after, .xs-testimonial-slider .owl-item .xs-testimonial-item {
  background-color: transparent;
  background-image: linear-gradient(90deg, #15095e 0%, #1045db 100%);
}

.elementor-36 .elementor-element.elementor-element-b0fe0d1 .xs-testimonial-slider .owl-item:not(.center) .xs-testimonial-item {
  opacity: 0.5;
}

.elementor-36 .elementor-element.elementor-element-b0fe0d1 .commentor-bio .commentor-title {
  color: #ffffff;
}

.elementor-36 .elementor-element.elementor-element-b0fe0d1 .xs-testimonial-slider .owl-item.center .testimonial-content .commentor-info {
  color: #ffffff;
}

.elementor-36 .elementor-element.elementor-element-b0fe0d1 .xs-testimonial-slider .owl-item:not(.center) .xs-testimonial-item p.commentor-info {
  color: #ffffff;
}

.elementor-36 .elementor-element.elementor-element-b0fe0d1 .testimonial-content > p {
  color: #ffffff;
}

.elementor-36 .elementor-element.elementor-element-b0fe0d1 .xs-testimonial-slider .owl-item:not(.center) .xs-testimonial-item p {
  color: #ffffff;
}

.elementor-36 .elementor-element.elementor-element-bc980b0 {
  margin-top: -100px;
  margin-bottom: 0px;
}

.elementor-36 .elementor-element.elementor-element-f5516c2 {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  margin-top: 0px;
  margin-bottom: -98px;
  padding: 100px 0px 0px 0px;
  z-index: 33;
}

.elementor-36 .elementor-element.elementor-element-f5516c2 > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-36 .elementor-element.elementor-element-dfea7b2 > .elementor-element-populated {
  padding: 0px 15px 0px 15px;
}

.elementor-36 .elementor-element.elementor-element-6832010 .xs-feature-group {
  background-color: #ffffff;
}

.elementor-36 .elementor-element.elementor-element-6832010 .xs-feature-group .xs-title {
  color: #1e1e1e;
}

.elementor-36 .elementor-element.elementor-element-6832010 .xs-feature-group p {
  color: #70799f;
}

.elementor-36 .elementor-element.elementor-element-6832010 .btn-secondary {
  color: #ffffff;
  background-color: #1868dd;
}

.elementor-36 .elementor-element.elementor-element-6832010 {
  z-index: 2;
}

.elementor-36 .elementor-element.elementor-element-6832010 > .elementor-widget-container {
  box-shadow: 0px -10px 25px 0px rgba(0, 0, 0, 0.04);
}

.elementor-36 .elementor-element.elementor-element-a71815c > .elementor-element-populated {
  padding: 0px 15px 0px 15px;
}

.elementor-36 .elementor-element.elementor-element-a0eeee3 .xs-feature-group {
  background-color: #ffffff;
}

.elementor-36 .elementor-element.elementor-element-a0eeee3 .xs-feature-group .xs-title {
  color: #1e1e1e;
}

.elementor-36 .elementor-element.elementor-element-a0eeee3 .xs-feature-group p {
  color: #70799f;
}

.elementor-36 .elementor-element.elementor-element-a0eeee3 .btn-secondary {
  color: #ffffff;
  background-color: #1868dd;
}

.elementor-36 .elementor-element.elementor-element-a0eeee3 {
  z-index: 2;
}

.elementor-36 .elementor-element.elementor-element-a0eeee3 > .elementor-widget-container {
  box-shadow: 0px -10px 25px 0px rgba(0, 0, 0, 0.04);
}

.elementor-36 .elementor-element.elementor-element-4d5ed22:not(.elementor-motion-effects-element-type-background), .elementor-36 .elementor-element.elementor-element-4d5ed22 > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-color: #113072;
}

.elementor-36 .elementor-element.elementor-element-4d5ed22 {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
}

.elementor-36 .elementor-element.elementor-element-4d5ed22 > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-36 .elementor-element.elementor-element-8df6d89 .elementor-spacer-inner {
  height: 80px;
}

@media (min-width: 768px) {
  .elementor-36 .elementor-element.elementor-element-c6df752 {
    width: 15%;
  }

  .elementor-36 .elementor-element.elementor-element-23201c9 {
    width: 69.332%;
  }

  .elementor-36 .elementor-element.elementor-element-d2a7f51 {
    width: 15%;
  }

  .elementor-36 .elementor-element.elementor-element-b8d92ab {
    width: 15%;
  }

  .elementor-36 .elementor-element.elementor-element-645f601 {
    width: 69.332%;
  }

  .elementor-36 .elementor-element.elementor-element-0eb1e64 {
    width: 15%;
  }

  .elementor-36 .elementor-element.elementor-element-37c566e {
    width: 20%;
  }

  .elementor-36 .elementor-element.elementor-element-b4f7341 {
    width: 59.332%;
  }

  .elementor-36 .elementor-element.elementor-element-efca547 {
    width: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Support.vue